/**
 * RadNeo™ Design System — Transition Tokens
 */

export const duration = {
  fast: 150,
  normal: 250,
  slow: 400,
} as const;

export const easing = {
  standard: 'cubic-bezier(0.4, 0, 0.2, 1)',
  enter: 'cubic-bezier(0, 0, 0.2, 1)',
  exit: 'cubic-bezier(0.4, 0, 1, 1)',
  bounce: 'cubic-bezier(0.34, 1.56, 0.64, 1)',
} as const;

export const transitions = {
  fast: `all ${duration.fast}ms ${easing.standard}`,
  normal: `all ${duration.normal}ms ${easing.standard}`,
  slow: `all ${duration.slow}ms ${easing.standard}`,
  focus: `box-shadow ${duration.fast}ms ${easing.standard}`,
} as const;
